import { FeatureFlag } from '@/constants/featureFlags';
import type { ValueOf } from '@/types';

declare module 'vue-router' {
	interface RouteMeta {
		// Route only navigates client-side while this flag is on.
		requiresFeatureFlag?: ValueOf<typeof FeatureFlag>;
	}
}

export const projectsListRoute = {
	path: '/projects/:filterHash?',
	name: 'projectsList',
	component: () => import('@/pages/projects/ProjectsListPage.vue'),
	meta: { requiresFeatureFlag: FeatureFlag.VUE_APP_FRAME },
};

export const contactsListRoute = {
	path: '/contacts/:filterHash?',
	name: 'contactsList',
	component: () => import('@/pages/contacts/ContactsListPage.vue'),
	meta: { requiresFeatureFlag: FeatureFlag.VUE_APP_FRAME },
};

export const projectsViewRoute = {
	path: '/projects/view/:projectId*',
	name: 'projectsView',
	component: () => import('@/pages/projects/ProjectsView.vue'),
};

export const welcomeRoute = {
	path: '/welcome',
	name: 'welcome',
	component: () => import('@/pages/welcome/WelcomeIndex.vue'),
};

export const packageConfigureRoute = {
	path: '/settings/package/configure',
	name: 'settingsPackageConfigure',
	component: () =>
		import('@/pages/settings/packageConfigure/PackageConfigurePage.vue'),
};
